import {
  ElAffix,
  ElAvatar,
  ElButton,
  ElCol,
  ElContainer,
  ElDivider,
  ElFooter,
  ElForm,
  ElFormItem,
  ElHeader,
  ElIcon,
  ElInput,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElPageHeader,
  ElRow,
  ElSubmenu,
  ElMessageBox,
  ElMessage,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElLoading,
  ElTooltip,
  ElDialog,
  ElSwitch,
  ElSelect,
  ElOption,
  ElBacktop,
  ElScrollbar,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElCard,
  ElLink,
  ElDatePicker,
  ElCollapseTransition,
  ElTag,
  ElCheckbox,
  ElCheckboxGroup,
  ElButtonGroup,
} from "element-plus";
import lang from "element-plus/lib/locale/lang/ja";
import locale from "element-plus/lib/locale";
import { App } from "vue";

export const components: Array<any> = [
  ElButton,
  ElContainer,
  ElHeader,
  ElMain,
  ElFooter,
  ElForm,
  ElFormItem,
  ElInput,
  ElIcon,
  ElSubmenu,
  ElMenu,
  ElMenuItem,
  ElDivider,
  ElRow,
  ElCol,
  ElAvatar,
  ElAffix,
  ElPageHeader,
  ElMessageBox,
  ElMessage,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElLoading,
  ElTooltip,
  ElDialog,
  ElSwitch,
  ElSelect,
  ElOption,
  ElBacktop,
  ElScrollbar,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElCard,
  ElLink,
  ElCollapseTransition,
  ElTag,
  ElCheckboxGroup,
  ElCheckbox,
  ElButtonGroup,
  // ElAlert,
  // ElAside,
  // ElAutocomplete,
  // ElBadge,
  // ElBreadcrumb,
  // ElBreadcrumbItem,
  // ElCalendar,
  // ElCarousel,
  // ElCarouselItem,
  // ElCascader,
  // ElCascaderPanel,
  // ElCheckboxButton,
  // ElCollapse,
  // ElCollapseItem,
  // ElColorPicker,
  // ElContainer,
  // ElDrawer,
  // ElHeader,
  // ElImage,
  // ElInputNumber,
  // ElMenuItemGroup,
  // ElOptionGroup,
  // ElPopconfirm,
  // ElPopover,
  // ElPopper,
  // ElProgress,
  // ElRadio,
  // ElRadioButton,
  // ElRadioGroup,
  // ElRate,
  // ElSlider,
  // ElStep,
  // ElSteps,
  // ElTabPane,
  // ElTabs,
  // ElTimePicker,
  // ElTimeSelect,
  // ElTimeline,
  // ElTimelineItem,
  // ElTransfer,
  // ElTree,
  // ElUpload,
  // ElInfiniteScroll,
  // ElNotification,
];

const components2 = [ElDatePicker]; //ElDatePickerは単体テストでは使えないため、別Arrayで管理。
export default (app: App<Element>) => {
  locale.use(lang);
  components.concat(components2).forEach((item) => app.use(item));
};
